export const tableUrls = {
    additionalColumns: "upsert-extra-fields-info",
    additionalColumnCellEdit: "upsert-table-cell"
};
